export enum OrderType {
    TariffsOrder = 1,
    ArenaTicket = 2
}